module.exports = __webpack_public_path__ + "static/main-img-bg-58afeda3f2f5e2bcaf73268ef0928d63.png";